
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const HormoneInfo = () => {
  const hormones = [
    {
      name: "Estrogène",
      color: "bg-red-500",
      description: "Hormone responsable du développement des caractères sexuels féminins",
      effects: ["Croissance de l'endomètre", "Développement folliculaire", "Production de glaire cervicale"]
    },
    {
      name: "Progestérone",
      color: "bg-purple-300",
      description: "Hormone préparant l'utérus pour une éventuelle grossesse",
      effects: ["Maintien de l'endomètre", "Augmentation de la température corporelle", "Diminution de la glaire cervicale"]
    },
    {
      name: "LH (Hormone lutéinisante)",
      color: "bg-yellow-100",
      description: "Hormone déclenchant l'ovulation",
      effects: ["Maturation finale de l'ovule", "Déclenchement de l'ovulation", "Formation du corps jaune"]
    },
    {
      name: "FSH (Hormone folliculo-stimulante)",
      color: "bg-green-100",
      description: "Hormone stimulant le développement des follicules",
      effects: ["Croissance des follicules", "Production d'estrogène", "Maturation des ovules"]
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {hormones.map((hormone) => (
        <Card key={hormone.name}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <div className={`w-4 h-4 rounded-full ${hormone.color}`} />
              {hormone.name}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-2">{hormone.description}</p>
            <ul className="list-disc list-inside text-sm">
              {hormone.effects.map((effect, index) => (
                <li key={index}>{effect}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
